var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ruleData &&
    _vm.isTeamOwner &&
    _vm.rateText.length > 0 &&
    _vm.rate.isBaseCharge &&
    _vm.rateIndex === 0
    ? _c(
        "md-tooltip",
        { staticClass: "message-container", attrs: { "md-direction": "top" } },
        _vm._l(_vm.rateText, function (text, index) {
          return _c("div", { key: index }, [
            _vm._v("\n        " + _vm._s(text) + "\n    "),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }